/* ============================================================================
   M7 · Buy box behaviour (PDP buy box + landing shop band).

   Four jobs:
     1. Keep the CTA price AND the form quantity in step with the selected
        plan (two-person = quantity 2 of the same variant + selling plan).
     2. Run the P6 dispatch countdown to the next midnight America/New_York.
     3. Run the P5 typewriter line ("Comprehensive support for <word>").
     4. Smooth-scroll the P1 star row's same-page anchor.

   Selection/collapse state itself is CSS (:has on the checked radio), so the
   card visuals cannot drift from what posts to the cart. No libraries.
   ========================================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- 1 · CTA price + quantity mirror the selected plan ------------------ */

  document.querySelectorAll('[data-buy-box]').forEach(function (root) {
    var priceEl = root.querySelector('[data-cta-price]');
    var qtyInput = root.querySelector('[data-quantity-input]');

    // Match the store's money format from the value Liquid already rendered,
    // rather than reimplementing money_format in JS and drifting from it.
    var template = priceEl ? priceEl.textContent.trim() : '';

    function formatFromTemplate(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // Swap the digits inside the original string, preserving currency
      // symbol, placement and any suffix (e.g. "$81.75 USD").
      return template.replace(/[\d.,]+/, whole + '.' + parts[1]);
    }

    function syncSelection() {
      var checked = root.querySelector('[data-plan]:checked');
      if (!checked) return;
      if (priceEl && template) {
        var cents = parseInt(checked.getAttribute('data-price'), 10);
        if (!isNaN(cents)) priceEl.textContent = formatFromTemplate(cents);
      }
      if (qtyInput) {
        var qty = parseInt(checked.getAttribute('data-quantity'), 10);
        qtyInput.value = isNaN(qty) || qty < 1 ? 1 : qty;
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-plan]')) syncSelection();
    });
    syncSelection();
  });

  /* --- 2 · Countdown to the next midnight America/New_York ---------------- */
  /* "ORDER IN THE NEXT HH:MM:SS FOR NEXT BUSINESS DAY SHIPPING" — client note
     P6. Computed each tick via Intl with the timeZone option, so it is
     correct for every visitor and rolls over daily on its own. */

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  document.querySelectorAll('[data-countdown]').forEach(function (countdown) {
    var clock = countdown.querySelector('[data-countdown-clock]');
    if (!clock) return;

    var tz = countdown.getAttribute('data-countdown-tz') || 'America/New_York';
    var fmt = null;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, hour12: false,
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    } catch (err) {
      fmt = null; // unknown zone / ancient engine — fall back to local time
    }

    function secondsToMidnight() {
      var now = new Date();
      var h, m, s;
      if (fmt) {
        var parts = fmt.format(now).split(':');
        h = parseInt(parts[0], 10) % 24; // some engines render midnight as 24
        m = parseInt(parts[1], 10);
        s = parseInt(parts[2], 10);
      } else {
        h = now.getHours(); m = now.getMinutes(); s = now.getSeconds();
      }
      return (86400 - (h * 3600 + m * 60 + s)) % 86400;
    }

    function tick() {
      var left = secondsToMidnight();
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      clock.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      clock.setAttribute('datetime', 'PT' + h + 'H' + m + 'M' + s + 'S');
    }

    tick();

    // A live-ticking clock is still motion: hold it static for anyone who has
    // asked for less.
    var timer = null;
    function applyMotionPreference() {
      if (reduced.matches) {
        if (timer) { clearInterval(timer); timer = null; }
      } else if (!timer) {
        timer = setInterval(tick, 1000);
      }
    }

    applyMotionPreference();
    reduced.addEventListener('change', applyMotionPreference);

    // Don't burn a timer on a page nobody is looking at.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (timer) { clearInterval(timer); timer = null; }
      } else {
        tick();
        applyMotionPreference();
      }
    });
  });

  /* --- 3 · Typewriter line ------------------------------------------------ */
  /* Markup (snippets/buy-box-typeline.liquid) ships with the first word
     already in place, so with no JS — or with reduced motion — the line reads
     as a static sentence. */

  document.querySelectorAll('[data-typewriter]').forEach(function (line) {
    var wordEl = line.querySelector('[data-typewriter-word]');
    if (!wordEl) return;

    var words = (line.getAttribute('data-typewriter-words') || '')
      .split(',')
      .map(function (w) { return w.trim(); })
      .filter(function (w) { return w.length > 0; });
    if (words.length < 2) return;

    var TYPE_MS = 70, DELETE_MS = 40, HOLD_MS = 1700, GAP_MS = 350;
    var index = 0, timer = null;

    function schedule(fn, ms) { timer = setTimeout(fn, ms); }

    function typeWord(word, at) {
      if (at <= word.length) {
        wordEl.textContent = word.slice(0, at);
        schedule(function () { typeWord(word, at + 1); }, TYPE_MS);
      } else {
        schedule(deleteWord, HOLD_MS);
      }
    }

    function deleteWord() {
      var current = wordEl.textContent;
      if (current.length > 0) {
        wordEl.textContent = current.slice(0, -1);
        schedule(deleteWord, DELETE_MS);
      } else {
        index = (index + 1) % words.length;
        schedule(function () { typeWord(words[index], 1); }, GAP_MS);
      }
    }

    function stop() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function start() {
      stop();
      // Resume by typing the next word out of whatever is on screen.
      schedule(deleteWord, HOLD_MS);
    }

    function applyMotionPreference() {
      if (reduced.matches) {
        stop();
        wordEl.textContent = words[0]; // static first word
        index = 0;
      } else {
        start();
      }
    }

    applyMotionPreference();
    reduced.addEventListener('change', applyMotionPreference);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else applyMotionPreference();
    });
  });

  /* --- 4 · Star row: same-page anchors ride native navigation ------------- */
  /* No JS. Horizon's scroll management silently swallows every programmatic
     scroll on this page (scrollIntoView / scrollTo / scrollTop assignments
     all no-op back to the current offset — verified 4 Aug 2026), so an
     intercepted click goes NOWHERE. Native hash navigation is performed by
     the browser itself and is immune, `scroll-behavior: smooth` on <html>
     makes it smooth, and the anchor's scroll-margin-top handles the header
     offset. Real paths (/pages/reviews on the landing) navigate normally. */
})();
